<template>
<v-container>
 <!-- <particles-bg type="lines" :bg="true" /> -->

    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.message }}
    </v-snackbar>


    <div class="containerzz" style="margin-top: 150px">
        <div class="screen">
            <div class="screen__content">
            <v-card color="rgba(217, 217, 217, 0.8)" >
                <div class="text-center mb-3 mt-3">
                    <v-row align="center" justify="center">
                        <v-col cols="6">
                            <v-card
                                class="mx-auto ml-2 mr-2"
                                max-width="344"
                                shaped
                            >
                                <v-card-title>DASHBOARD</v-card-title>
                                <v-img
                                    src="@/assets/HIES.png"
                                    class="mt-2 mb-2"
                                    height="120"
                                ></v-img>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-btn
                                     color="secondary"
                                     rounded
                                     medium
                                     class="elevation-10"
                                     @click="openDashboard"
                                    >
                                    Dashboard
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
                
                <v-divider> </v-divider> 
                <v-card-action >
                    <v-form ref="form" class="login">
                            <!-- <v-row justify="center">
                                <v-avatar
                                color="black"
                                size="128"
                                >
                                <img
                                    src="@/assets/HIES1.jpg"
                                    alt="John"
                                >
                                </v-avatar>
                            </v-row> -->
                            <div class="login__field" v-show="poForm">
                                <i class="login__icon fas fa-user"></i>
                                <v-text-field 
                                type="text" 
                                class="login__input" 
                                placeholder="Emel" 
                                v-model="logmasukemel"
                                :rules="[required('emel'), rules.email]"
                                ></v-text-field>
                            </div>
                            <div class="login__field" v-show="poForm">
                                <i class="login__icon fas fa-lock"></i>
                                <v-text-field
                                type="password" 
                                class="login__input" 
                                placeholder="Password"
                                v-model="logmasukkatalaluan"
                                :rules="logmasukkatalaluanRules"
                                ></v-text-field>
                            </div>

                            <div class="login__field" v-show="respondenForm">
                                <i class="login__icon fas fa-id-card"></i>
                                <v-text-field
                                type="text" 
                                class="login__input" 
                                placeholder="HID"
                                v-model="HID"
                                ></v-text-field>
                            </div>
                            <div class="login__field" v-show="respondenForm">
                                <i class="login__icon fas fa-key"></i>
                                <v-text-field
                                type="text" 
                                class="login__input" 
                                placeholder="TAC"
                                v-model="TAC"
                                ></v-text-field>
                            </div>

                            <div>
                                <v-btn
                                    elevation="8"
                                    x-small
                                    color="primary"
                                    dark
                                    rounded
                                    @click="respondenForm=true;poForm=false;"
                                    >
                                    Responden
                                    </v-btn>
                                    &nbsp;
                                    <v-btn
                                    elevation="8"
                                    x-small
                                    color="primary"
                                    dark
                                    rounded
                                    @click="respondenForm=false;poForm=true;"
                                    >
                                    DOSM
                                </v-btn>


                            </div>

                            <v-btn class="button login__submit" @click="logmasuk" v-show="poForm">
                                <span class="button__text">Log Masuk - dev</span>
                                <i class="button__icon fas fa-chevron-right"></i>
                            </v-btn>
                            <v-btn class="button login__submit" @click="logmasukHID" v-show="respondenForm" :disabled='isDisabled'>
                                <span class="button__text">Log Masuk  - dev</span>
                                <i class="button__icon fas fa-chevron-right"></i>
                            </v-btn>				
                    </v-form>
                </v-card-action>
                </v-card>
            </div>
            <div class="screen__background">
                <!-- <span class="screen__background__shape screen__background__shape4"></span> -->
                <!-- <span class="screen__background__shape screen__background__shape3"></span>		 -->
                <!-- <span class="screen__background__shape screen__background__shape2"></span> -->
                <!-- <span class="screen__background__shape screen__background__shape1"></span> -->
            </div>		
        </div>
    </div>
    

    <v-dialog
                  v-model="dialogpaparperanan"
                  persistent
                  max-width="500px"
                >
                    <v-card>
                        <v-form ref="formloginpilihanperanan">
                        <v-card-title>
                        <span class="text-h5">{{$t('pilih')}} {{$t('peranan')}}</span>
                        </v-card-title>
                        <v-card-text>
                        <v-container>
                            <v-row>
                                <v-select
                                    prepend-icon="fa-user"
                                    outlined dense
                                    :items="pilihperanan"
                                    v-model="logmasukperananpilihanperanan"
                                    v-bind:label="$t('peranan')"
                                    :rules="[required('peranan')]"
                                    item-text="nama"
                                    item-value="id"
                                ></v-select>
                            </v-row>
                        </v-container>
                        </v-card-text>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="dialogpaparperanan = false"
                        >
                          {{$t('tutup')}} 
                        </v-btn>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="logmasukperananpilihan()"
                        >
                          {{$t('hantar')}} 
                        </v-btn>
                        </v-card-actions>
                        </v-form>
                    </v-card>
    </v-dialog>

    <v-alert
      v-show="toggle"
      color="pink"
      dark
      border="top"
      icon="mdi-circle"
      transition="scale-transition"
    >
     Pengisian bagi HID ini telah selesai!
    </v-alert>


</v-container>



        
</template>
<script>
import axios from 'axios'
import i18n from '@/i18n'
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage();

//////////////services//////////////////
import pubServices from '@/services/publicServices'
const publicServices = new pubServices();

import { ParticlesBg } from "particles-bg-vue";
export default {
    name: 'Logmasuk',
    // components: {
    //     ParticlesBg
    // },
    data() {
        return {
            snackbar: "",
            loading: false,
            poForm: true,
            isDisabled: true,
            respondenForm: false,
            dialogpaparperanan: false,
            pilihperanan: [],
            publicHIDdata:'',
            HID:'',
            TAC:"",
            toggle: false,
            logmasukemel: '',
            logmasuknama: '',
            logmasukkatalaluan: '',
            logmasukperananpilihanemel: '',
            logmasukperananpilihankatalaluan: '',
            logmasukperananpilihanperanan: '',
            required(text){
                return (v) => 
                (v && v.length > 0) || `${i18n.t(text)} ${i18n.t('adalah diperlukan')}`
            },
            rules: {
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || `${i18n.t('emeltidaklengkap')}`;
                },
            },
            logmasuknamaRules: [
                v => !!v || 'Name is required',
                v => (v && v.length >= 6) || 'Name must be more than 6 characters',
            ],
            logmasukkatalaluanRules: [
                v => !!v || `${i18n.t('Password adalah diperlukan')}`
            ],
            res: null,
            // validation: {
            //     logmasuknama: false,
            //     logmasukkatalaluan: false
            // },
            defaultError: null
        }
    },
    props: {
        source: String
    },
    methods:{
        async logmasuk(){
            // this.$router.push('/paparanutama')
            // console.log(this.logmasuknama)
            // console.log(this.logmasukkatalaluan)
            // if(!this.logmasuknama){
            //     this.logmasuknamareq = 'sila isi'
            // }
            // if(!this.logmasukkatalaluan){
            //     this.logmasukkatalaluanreq = 'sila isi'
            // }
            if(this.$refs.form.validate()){
                setTimeout(() => {
                
                }, 2000);
                await axios.post(`${process.env.VUE_APP_API_URL}/auth/logmasuk`, {
                    logmasukemel: this.logmasukemel,
                    logmasukkatalaluan: this.logmasukkatalaluan
                })
                .then(response => {
                    //console.log(response.data.status)
                    if(!response.data.status){
                        if(response.data.message === 'Pilih peranan'){
                            this.dialogpaparperanan = true
                            this.pilihperanan = response.data.pilihperanan
                            this.logmasukperananpilihanperanan = ''
                        } else {
                            this.snackbar = {
                                message: `${response.data.message}`,
                                timeout: 2000,
                                color: "red darken-4",
                                show: true,
                            };
                        }    
                    } else {
                        window.localStorage.setItem('tokenexport', response.data.data.tokenexport)
                        window.localStorage.setItem('access_token', response.data.data.token)
                        window.localStorage.setItem('user', JSON.stringify(response.data.data.user))
                        this.loading = false
                        this.$router.push(`/${i18n.locale}/paparanutama`)
                    }
                })
                .catch(error => {
                    console.log(error)
                    //console.log(error)
                })
            }
        },
        async logmasukHID(){
            try{
                var res = await publicServices.getBorangByHID(this.HID);//dapatkan data HID
                await axios.post(`${process.env.VUE_APP_API_URL}/public/logmasukresponden?`, {
                    HID:this.HID,
                    HIESID:this.TAC
                }).then(result=>{
                    if(result.data.status){
                        this.publicHIDdata = res.data.data;
                        var statusHID = res.data.data.statusHID;

                        if(statusHID == 1){
                            localStorageData.setHID(this.publicHIDdata)
                            window.localStorage.setItem('access_token', result.data.data.token)
                            window.localStorage.setItem('user', JSON.stringify(result.data.data.user))
                            this.loading = false
                            this.$router.push(`/${i18n.locale}/ringkasanMaklumatIR`)
                            // this.publicHIDdata = res.data.data;
                            // var setHIDtoLocalStorage = localStorageData.setHID(this.publicHIDdata);//setkan data HID ke dalam local storage
                            // window.localStorage.setItem('access_token', "PuBl1CK3Y")
                            // this.$router.push({name: "ringkasanMaklumatIR"});

                        }else{
                            this.toggle = true;
                            setTimeout(() => (this.toggle = false), 2000);
                        }
                        
                    } else {
                        this.snackbar = {
                            message: i18n.t("berjaya"),
                            timeout: 2000,
                            color: "success",
                            show: true,
                        };
                    }
                    
                })

            }catch(err){
                console.log(err)
            }

        },
        async logmasukperananpilihan(){
            if(this.$refs.form.validate()){
                this.logmasukperananpilihanemel = this.logmasukemel
                this.logmasukperananpilihankatalaluan = this.logmasukkatalaluan
                //console.log(`${this.logmasukperananpilihanemel} ${this.logmasukperananpilihankatalaluan} ${this.logmasukperananpilihanperanan}`)
                await axios.post(`${process.env.VUE_APP_API_URL}/auth/logmasukpelbagaiperanan`, {
                    logmasukperananpilihanemel: this.logmasukperananpilihanemel,
                    logmasukperananpilihankatalaluan: this.logmasukperananpilihankatalaluan,
                    logmasukperananpilihanperanan: this.logmasukperananpilihanperanan
                })
                .then(response => {
                    if(!response.data.status){ 
                        this.snackbar = {
                            message: `${response.data.message}`,
                            timeout: 2000,
                            color: "red darken-4",
                            show: true,
                        };
                    } else {
                        window.localStorage.setItem('tokenexport', response.data.data.tokenexport)
                        window.localStorage.setItem('access_token', response.data.data.token)
                        window.localStorage.setItem('user', JSON.stringify(response.data.data.user))
                        // alert('Loggin')
                        this.loading = false
                        this.$router.push(`/${i18n.locale}/paparanutama`)
                    }
                })
                .catch(error => {
                    console.log(error)
                    //alert(error)
                })
            }
        },
        openDashboard() {
            window.open(
                'https://app.powerbi.com/view?r=eyJrIjoiYTEyZWRlNjktNzgxNS00ODY4LTgyNjAtYjA5ZTlkNjgwZjg0IiwidCI6IjM3M2U5MGQyLWQ5YTMtNDNiNS04MzJlLWM4ZTk4NDdhNzlmOCIsImMiOjEwfQ%3D%3D',
                '_blank'
            );
        }

    },
    watch:{
        HID(val){
            if(val.length >0){
                this.isDisabled = false;
            }else{
                this.isDisabled =  true;
            }
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Raleway:400,700');

/* * {
	box-sizing: border-box;
	margin: 0;
	padding: 0;	
	font-family: Raleway, sans-serif;
} */

/* body {
	background: linear-gradient(90deg, #C7C5F4, #776BCC);		
} */

body {
    overflow: hidden;
    height: auto;
}

.containerzz {
	display: flex;
	align-items: center;
	justify-content: center;
	max-height: 80vh;
    
}

.screen {		
	/* background: linear-gradient(90deg, #5D54A4, #7C78B8);		 */
	position: relative;	
	height: auto;
	width: 860px;	
	box-shadow: 0px 0px 24px #5C5696;
}

.screen__content {
	z-index: 1;
	position: relative;	
	height: 100%;
    background-color: rgba(215, 255, 255, 0.3);
}

.screen__background {		
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 0;
	-webkit-clip-path: inset(0 0 0 0);
	clip-path: inset(0 0 0 0);	
}

.screen__background__shape {
	transform: rotate(45deg);
	position: absolute;
}

.screen__background__shape1 {
	height: 520px;
	width: 520px;
	background: #FFF;	
	top: -50px;
	right: 120px;	
	border-radius: 0 72px 0 0;
}

.screen__background__shape2 {
	height: 220px;
	width: 220px;
	background: #6C63AC;	
	top: -172px;
	right: 0;	
	border-radius: 32px;
}

.screen__background__shape3 {
	height: 600px;
	width: 290px;
	/* background: linear-gradient(270deg, #5D54A4, #6A679E); */
    background: #64C21A;
	top: -24px;
	right: 0;	
	border-radius: 32px;
}

.screen__background__shape4 {
	height: 400px;
	width: 200px;
	background: #7E7BB9;	
	top: 420px;
	right: 50px;	
	border-radius: 60px;
}

.login {
	width: 100%;
	padding: 30px;
	padding-top: 80px;
}

.login__field {
	padding: 20px 0px;	
	position: relative;	
}

.login__icon {
	position: absolute;
	top: 30px;
	color: #7875B5;
}

.login__input {
	border: none;
	/* border-bottom: 2px solid #D1D1D4; */
	background: none;
	padding: 10px;
	padding-left: 24px;
	font-weight: 700;
	width: 95%;
	transition: .2s;
}

.login__input:active,
.login__input:focus,
.login__input:hover {
	outline: none;
	border-bottom-color: #6A679E;
}

.login__submit {
	background: #fff;
	font-size: 14px;
	margin-top: 30px;
	padding: 16px 20px;
	border-radius: 26px;
	border: 1px solid #D4D3E8;
	text-transform: uppercase;
	font-weight: 700;
	display: flex;
	align-items: center;
	width: 100%;
	color: #4C489D;
	box-shadow: 0px 2px 2px #5C5696;
	cursor: pointer;
	transition: .2s;
}

.login__submit:active,
.login__submit:focus,
.login__submit:hover {
	border-color: #6A679E;
	outline: none;
}

.button__icon {
	font-size: 24px;
	margin-left: auto;
	color: #7875B5;
}

.social-login {	
	position: absolute;
	height: 140px;
	width: 160px;
	text-align: center;
	bottom: 0px;
	right: 0px;
	color: #fff;
}

.social-icons {
	display: flex;
	align-items: center;
	justify-content: center;
}

.social-login__icon {
	padding: 20px 10px;
	color: #fff;
	text-decoration: none;	
	text-shadow: 0px 0px 8px #7875B5;
}

.social-login__icon:hover {
	transform: scale(1.5);	
}


.v-card__text {
  color: black!important;
  font-size: 16px;
}

</style>